if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      document.addEventListener('DOMContentLoaded', this.setTransparentClass.bind(this));

      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
          window.dispatchEvent(new Event('scroll'));
        } else {
          this.classList.add('is-sticky');
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      this.setAnnouncementHeight();
      this.announcementObserver = new ResizeObserver(() => {
        this.setAnnouncementHeight();
        this.setHeaderOffset();
        this.setHeaderHeight();
        this.setStickyClass();
      });
      const announcement = document.querySelector('.announcement-bar-section');
      if (announcement) this.announcementObserver.observe(announcement);

      window.dispatchEvent(new Event('scroll'));

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    disconnectedCallback() {
      this.announcementObserver?.disconnect();
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        // Compare viewport coordinates directly: Safari can report fractional scroll positions.
        const stickyTop = parseFloat(getComputedStyle(this.header_section).top) || 0;
        const isSticky = window.scrollY > 0 && this.header_section.getBoundingClientRect().top <= stickyTop + 1;
        this.classList.toggle('is-sticky', isSticky);
        document.querySelector('.product-information')?.classList.toggle('is-sticky', isSticky);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      this.announcementHeight = a_bar ? a_bar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--announcement-height', this.announcementHeight + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
      const announcement = document.querySelector('.announcement-bar-section');
      const visibleHeight = announcement ? Math.max(0, Math.min(announcement.getBoundingClientRect().bottom, this.announcementHeight || 0)) : 0;
      document.documentElement.style.setProperty('--announcement-visible-height', visibleHeight + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
    setTransparentClass() {
      this.template_header = document.querySelector('.template-header');

      if (this.template_header && this.template_header.classList.contains('template-header--has-image-true') && this.template_header.dataset.sectionIndex == 1) {
        this.classList.remove('transparent--false');
        this.classList.add('transparent--true');
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
